import {Component, OnInit} from '@angular/core';

//services
import { InformationService} from '../services/information.service';

@Component({
    selector: 'app-skills',
    templateUrl: './skills.component.html',
    styleUrls: ['./skills.component.css'],
    providers: [ InformationService ]
})
export class SkillsComponent implements OnInit{
    welcome : string;
    subtitle : string;
    loading: string;
    languages: any[] = [];
    awards: any[] = [];
    others: any[] = [];

    constructor(private informationService: InformationService){
        this.welcome = "What else?";
        this.subtitle = "Not about George Clooney, just a couple of skills and abilities that I have!";
        this.loading = "Loading...";
    }

    ngOnInit() {
        this.informationService.getLanguages().subscribe(response => {this.languages = response.json()});
        this.informationService.getAwards().subscribe(response => {this.awards = response.json()});
        this.informationService.getOthers().subscribe(response => {this.others = response.json()});
    }
};